import React, { useState } from "react"

const Chain = ({ color = "default", url }) => {
  const strokeColor = color === "dark" ? "#ffffff" : "#121212"
  const iconColor = color === "dark" ? "#ffffff" : "#121212"
  const [showTooltip, setShowTooltip] = useState(false)

  const handleCopyUrl = async () => {
    if (typeof window === "undefined") return

    try {
      await navigator.clipboard.writeText(url || window.location.href)
      setShowTooltip(true)
      setTimeout(() => setShowTooltip(false), 2000) // Nasconde il tooltip dopo 2 secondi
    } catch (err) {
      console.error("Errore nel copiare negli appunti:", err)
      // Fallback per browser più vecchi
      const textArea = document.createElement("textarea")
      textArea.value = url || window.location.href
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand("copy")
      document.body.removeChild(textArea)
      setShowTooltip(true)
      setTimeout(() => setShowTooltip(false), 2000)
    }
  }

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <svg
        width="61"
        height="60"
        viewBox="0 0 61 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
        onClick={handleCopyUrl}
        onMouseEnter={e => {
          const rect = e.currentTarget.querySelector("rect")
          const paths = e.currentTarget.querySelectorAll("path")
          if (rect) {
            rect.setAttribute("fill", strokeColor)
          }
          paths.forEach(path => {
            path.setAttribute("fill", color === "dark" ? "#121212" : "#ffffff")
          })
        }}
        onMouseLeave={e => {
          const rect = e.currentTarget.querySelector("rect")
          const paths = e.currentTarget.querySelectorAll("path")
          if (rect) {
            rect.setAttribute("fill", "none")
          }
          paths.forEach(path => {
            path.setAttribute("fill", iconColor)
          })
        }}
      >
        <rect
          x="1.53027"
          y="1"
          width="57.9698"
          height="58"
          rx="28.9849"
          stroke={strokeColor}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M34.4376 33.8223C35.8339 32.4093 36.6042 30.526 36.6042 28.5186C36.6042 26.8056 36.0487 25.189 35.0005 23.8464C34.8487 23.6519 34.6283 23.5279 34.3839 23.4982C34.1394 23.4686 33.895 23.5353 33.7005 23.6871C33.5061 23.839 33.382 24.0575 33.3505 24.3038C33.3209 24.5501 33.3876 24.7927 33.5394 24.9871C34.332 26.0019 34.7505 27.2242 34.7505 28.5205C34.7505 30.063 34.1542 31.5019 33.0709 32.5723C33.0487 32.5945 33.0283 32.6168 33.0079 32.6408L24.2413 41.4075C24.2172 41.4279 24.195 41.4482 24.1728 41.4705C23.1042 42.5538 21.6654 43.1501 20.1209 43.1501C16.9561 43.1501 14.3802 40.5742 14.3802 37.4093C14.3802 35.8668 14.9765 34.4279 16.0598 33.3575C16.082 33.3353 16.1024 33.313 16.1228 33.289L24.8894 24.5223C24.9135 24.5019 24.9357 24.4816 24.9579 24.4593C25.8431 23.563 27.0265 22.9816 28.2876 22.8242C28.5339 22.7927 28.7524 22.6686 28.9042 22.4742C29.0561 22.2797 29.1228 22.0353 29.0913 21.7908C29.0598 21.5445 28.9357 21.326 28.7394 21.1742C28.5431 21.0223 28.3005 20.9556 28.058 20.9871C26.4209 21.1927 24.8765 21.939 23.7079 23.0927C23.6857 23.1112 23.6635 23.1316 23.6431 23.1519L14.7542 32.039C14.7339 32.0593 14.7135 32.0816 14.695 32.1038C13.2987 33.5168 12.5283 35.4001 12.5283 37.4075C12.5283 41.5945 15.9339 45.0001 20.1209 45.0001C22.1283 45.0001 24.0117 44.2316 25.4246 42.8353C25.4468 42.8167 25.4691 42.7964 25.4894 42.776L34.3783 33.8871C34.3987 33.8667 34.4191 33.8445 34.4376 33.8223Z"
          fill={iconColor}
        />
        <path
          d="M40.8637 15C38.8563 15 36.973 15.7686 35.56 17.1649C35.5378 17.1834 35.5156 17.2037 35.4952 17.2241L26.6063 26.113C26.5859 26.1334 26.5656 26.1556 26.547 26.1778C25.1507 27.5908 24.3804 29.4741 24.3804 31.4815C24.3804 33.1241 24.8952 34.6871 25.8674 36C26.0137 36.1982 26.2304 36.3278 26.4748 36.3649C26.7193 36.4019 26.9637 36.3408 27.1619 36.1926C27.573 35.8889 27.6581 35.3074 27.3544 34.8982C26.6193 33.9056 26.2304 32.7241 26.2304 31.4797C26.2304 29.9371 26.8267 28.4982 27.91 27.4278C27.9322 27.4056 27.9526 27.3834 27.973 27.3593L36.7396 18.5926C36.7637 18.5723 36.7859 18.5519 36.8081 18.5297C37.8767 17.4463 39.3156 16.85 40.86 16.85C44.0248 16.85 46.6007 19.426 46.6007 22.5908C46.6007 24.1334 46.0044 25.5723 44.9211 26.6426C44.8989 26.6649 44.8785 26.6871 44.8582 26.7112L36.0915 35.4778C36.0674 35.4982 36.0433 35.5186 36.023 35.5408C35.1174 36.4593 33.9063 37.0426 32.61 37.1852C32.3637 37.213 32.1433 37.3334 31.9896 37.526C31.8359 37.7186 31.7656 37.9612 31.7915 38.2056C31.8433 38.676 32.2378 39.0297 32.71 39.0297C32.7433 39.0297 32.7785 39.0297 32.8119 39.0241C34.4952 38.8389 36.0785 38.0852 37.273 36.9056C37.2952 36.8871 37.3174 36.8667 37.3378 36.8463L46.2267 27.9574C46.247 27.9371 46.2674 27.9149 46.2859 27.8926C47.6822 26.4797 48.4526 24.5963 48.4526 22.5889C48.4526 18.4019 45.047 14.9963 40.86 14.9963L40.8637 15Z"
          fill={iconColor}
        />
      </svg>

      {showTooltip && (
        <div
          style={{
            position: "absolute",
            top: "-40px",
            left: "10%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "white",
            padding: "8px 12px",
            borderRadius: "4px",
            fontSize: "14px",
            whiteSpace: "nowrap",
            zIndex: 1000,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          Link copiato!
        </div>
      )}
    </div>
  )
}

export default Chain
